import $ from 'jquery'
(($, window, document) => {

    const Catering = {
      init() {
        this.hash();
      },
      hash() {
        // catering/book-event page: give an item an active class if it has a # in the URL
        if (window.location.hash) {
            var hash = window.location.hash.substring(1);
            var hashIndex = hash.substr(hash.length - 1);
            if ($(".catering-packages .item").length > 0) {
              $('.catering-packages .item:nth-child(' + hashIndex + ')').addClass("active");
            }
          }
      },
    }

    Catering.init();

})(jQuery, window, document);
